<template>
    <v-form ref="form" type="POST" class="theForm" @submit.prevent="handleSubmit">
        <div class="formInner">
            <div id="payment-fields">
                <v-card width="450px" class="pa-8">
                    <v-card-title class="pb-6 pt-0">
                        {{ $t('payment_details') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="6">
                                <div class="payment-field">
                                    <input v-model="firstName" type="text" placeholder="First Name" />
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="payment-field">
                                    <input v-model="lastName" type="text" placeholder="Last Name" />
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <div class="payment-field">
                                    <input v-model="email" type="text" placeholder="Email" />
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <div class="payment-field">
                                    <input v-model="address" type="text" placeholder="Billing Address" />
                                </div>
                            </v-col>
                            <v-col
                                v-if="showProgressCircular"
                                cols="12"
                                class="d-flex full-width justify-center align-center"
                            >
                                <v-progress-circular indeterminate color="primary" />
                            </v-col>
                            <v-col
                                :style="{
                                    position: showProgressCircular ? 'absolute' : 'relative',
                                    opacity: showProgressCircular ? '0' : '1',
                                }"
                                cols="12"
                            >
                                <div id="ccnumber" class="payment-field" />
                            </v-col>
                            <v-col
                                :style="{
                                    position: showProgressCircular ? 'absolute' : 'relative',
                                    opacity: showProgressCircular ? '0' : '1',
                                }"
                                cols="6"
                            >
                                <div id="ccexp" class="payment-field"
                            /></v-col>
                            <v-col
                                :style="{
                                    position: showProgressCircular ? 'absolute' : 'relative',
                                    opacity: showProgressCircular ? '0' : '1',
                                }"
                                cols="6"
                            >
                                <div id="cvv" class="payment-field"
                            /></v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" block type="submit" :loading="isSubmitting"> {{ $t('pay') }} </v-btn>
                    </v-card-actions>
                </v-card>
            </div>
        </div>
    </v-form>
</template>

<script lang="ts">
    import {Component, Emit, Vue} from 'vue-facing-decorator'

    @Component
    export class NMIPaymentForm extends Vue {
        isSubmitting = false

        firstName = null
        lastName = null
        email = null
        address = null
        token = null

        showProgressCircular = true

        mounted() {
            window.CollectJS.configure({
                variant: 'inline',
                styleSniffer: true,
                callback: token => {
                    this.finishSubmit(token)
                },
                validationCallback: (field, valid, message) => {},
                fieldsAvailableCallback: () => {
                    this.showProgressCircular = false
                },
                invalidCss: {
                    color: '#B40E3E',
                    'border-color': '#B40E3E',
                },
                customCss: {
                    'border-color': '#000000',
                    color: '#000000',
                    'border-style': 'solid',
                },
                fields: {
                    ccnumber: {
                        placeholder: 'Card Number',
                        selector: '#ccnumber',
                    },
                    ccexp: {
                        placeholder: 'MM/YY',
                        selector: '#ccexp',
                    },
                    cvv: {
                        placeholder: 'CVV',
                        selector: '#cvv',
                    },
                },
            })
        }

        @Emit()
        finishSubmit(response) {
            this.isSubmitting = false
            return {
                ...response,
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                address: this.address,
            }
        }

        handleSubmit(event) {
            event.preventDefault()
            this.isSubmitting = true
            window.CollectJS.startPaymentRequest()
        }
    }

    export default NMIPaymentForm
</script>

<style scoped lang="scss">
    :deep(.payment-field) {
        border-radius: 4px;
        box-shadow: 0 2px 8px #dddddd;

        input {
            padding: 12px 20px;
            width: 100%;
            border-color: rgb(118, 118, 118);
            outline: black;
        }
    }
</style>
